var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreActions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 292"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.52379 3.52415C2.36536 3.52415 3.04758 2.84192 3.04758 2.00035C3.04758 1.15879 2.36536 0.476562 1.52379 0.476562C0.682225 0.476562 0 1.15879 0 2.00035C0 2.84192 0.682225 3.52415 1.52379 3.52415Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.00035 3.52415C8.84192 3.52415 9.52415 2.84192 9.52415 2.00035C9.52415 1.15879 8.84192 0.476562 8.00035 0.476562C7.15879 0.476562 6.47656 1.15879 6.47656 2.00035C6.47656 2.84192 7.15879 3.52415 8.00035 3.52415Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.4769 3.52415C15.3185 3.52415 16.0007 2.84192 16.0007 2.00035C16.0007 1.15879 15.3185 0.476562 14.4769 0.476562C13.6353 0.476562 12.9531 1.15879 12.9531 2.00035C12.9531 2.84192 13.6353 3.52415 14.4769 3.52415Z",
    fill: "#222222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreActions);
export default __webpack_public_path__ + "static/media/moreActions.8f5705c6e1e4dc3c81954e4199168c1b.svg";
export { ForwardRef as ReactComponent };